// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3CB_8","icon":"styles_icon__xyQFH"};